<script setup lang="ts">
import { en, zh_cn } from '@nuxt/ui/locale';

const settingsStore = useSettingsStore();
const colorStore = useColorStore();
const uiLocale = computed(() => (settingsStore.language === 'en-US' ? en : zh_cn));

watch(
  () => settingsStore.language,
  (language) => {
    if (language !== 'zh-CN' && language !== 'en-US') {
      settingsStore.language = 'zh-CN';
      return;
    }
    document.documentElement.lang = language;
  },
  { immediate: true },
);
onMounted(() => {
  setTimezone(settingsStore.timezone);
  colorStore.updateProfitLossColor();
});
watch(
  () => settingsStore.timezone,
  (tz) => {
    setTimezone(tz);
  },
  { immediate: true },
);
</script>

<template>
  <UApp :locale="uiLocale">
    <div id="app" class="flex flex-col h-dvh" :style="colorStore.cssVars">
      <NavBar />
      <BodyLayout class="grow overflow-auto" />
      <NavFooter />
    </div>
  </UApp>
</template>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

/* * {
  outline: 1px solid #f00 !important;
} */
</style>
